import { __extends } from "tslib";
import React from 'react';
import { Bar, Doughnut, Line, Pie, Radar } from 'react-chartjs-2';
import { ButtonGroup, IButtonGroupButton } from "../ButtonGroup";
import { ChartTypes } from "../../models/chart";
import { ISelectedNode } from "../../models/node";
import { ITranslations } from "../../models/translations";
import { colorizeChart, colorizeOvalChart, customizeOvalChartLabel, customizeRadarChartLabel, generateChartColors, getChartLabels, getDataIndexes, getDataSets } from "../../utils/Chart";
import { IRgb } from "../../utils/Color";
import "../../../style/components/dashboards.scss";
var Dashboards = (function (_super) {
    __extends(Dashboards, _super);
    function Dashboards(props) {
        var _this = _super.call(this, props) || this;
        _this.preparedData = null;
        _this.chartBackgroundColor = [];
        _this.chartBorderColor = [];
        _this.renderChartSelector = function () {
            var selected = _this.state.selected;
            return (React.createElement(ButtonGroup, { buttons: _this.getChartOptions(), selected: selected, onClick: _this.onSelect }));
        };
        _this.getChartOptions = function () {
            var t = _this.props.t;
            return [
                { value: ChartTypes.bar, label: t.chartTypeBar },
                { value: ChartTypes.line, label: t.chartTypeLine },
                { value: ChartTypes.pie, label: t.chartTypePie },
                { value: ChartTypes.doughnut, label: t.chartTypeDoughnut },
                { value: ChartTypes.radar, label: t.chartTypeRadar },
            ];
        };
        _this.onSelect = function (newSelected) {
            _this.setState({
                selected: newSelected,
            });
        };
        _this.state = {
            selected: ChartTypes.bar,
        };
        return _this;
    }
    Dashboards.prototype.render = function () {
        var data = this.props.data;
        if (!data) {
            return null;
        }
        return (React.createElement("div", { className: 'rb-dashboards' },
            this.renderChartSelector(),
            React.createElement("div", { className: 'rb-chart-wrapper' },
                React.createElement("div", null, this.renderChart()))));
    };
    Dashboards.prototype.renderChart = function () {
        var selected = this.state.selected;
        var _a = this.props, data = _a.data, metrics = _a.metrics, dimensions = _a.dimensions, baseChartColors = _a.chartColors;
        if (!this.preparedData) {
            var headers = data && data.columnHeaders;
            var rows = data && data.rows;
            var metricIndexes = getDataIndexes(metrics, headers);
            var dimensionIndexes = getDataIndexes(dimensions, headers);
            var labels = getChartLabels(rows, dimensionIndexes);
            var datasets = getDataSets(rows, headers, metricIndexes);
            this.preparedData = {
                labels: labels,
                datasets: datasets,
            };
            var chartColors = generateChartColors(labels, datasets, baseChartColors);
            this.chartBackgroundColor = chartColors && chartColors.backgroundColor;
            this.chartBorderColor = chartColors && chartColors.borderColor;
        }
        if (!this.preparedData) {
            return null;
        }
        if (selected === ChartTypes.pie || selected === ChartTypes.doughnut) {
            colorizeOvalChart(this.preparedData.datasets, this.chartBackgroundColor);
        }
        else {
            colorizeChart(this.preparedData.datasets, this.chartBackgroundColor, this.chartBorderColor);
        }
        var options = {
            scales: {
                xAxes: [{
                        gridLines: {
                            borderDash: [8, 4],
                        },
                    }],
                yAxes: [{
                        gridLines: {
                            borderDash: [8, 4],
                        },
                    }],
            },
        };
        var ovalChartOptions = {
            tooltips: {
                callbacks: {
                    label: customizeOvalChartLabel,
                },
            },
        };
        if (selected === ChartTypes.line) {
            return React.createElement(Line, { data: this.preparedData, options: options });
        }
        if (selected === ChartTypes.radar) {
            var radarOptions = {
                scales: {
                    ticks: {
                        beginAtZero: true,
                    },
                },
                tooltips: {
                    callbacks: {
                        label: customizeRadarChartLabel,
                    },
                },
            };
            return React.createElement(Radar, { data: this.preparedData, options: radarOptions });
        }
        if (selected === ChartTypes.pie) {
            return React.createElement(Pie, { data: this.preparedData, options: ovalChartOptions });
        }
        if (selected === ChartTypes.doughnut) {
            return React.createElement(Doughnut, { data: this.preparedData, options: ovalChartOptions });
        }
        return React.createElement(Bar, { data: this.preparedData, options: options });
    };
    Dashboards.defaultProps = {
        chartColors: [
            { r: 145, g: 12, b: 46 },
            { r: 50, g: 61, b: 75 },
            { r: 219, g: 149, b: 92 },
        ],
    };
    return Dashboards;
}(React.PureComponent));
export { Dashboards };
